// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"9710e2a6","990":"483ae073"}[chunkId] + ".chunk.js";
};